import type { State } from '../../store/types.js';

import {
  activityCodesAvailableHealth,
  currentEmployeeUuid,
  getOrganizationId,
  getPartnersAndContacts,
  key,
  writeAccess,
} from '../../store/selectors';
import type { AbstractPageView } from 'src/pages/abstract-page-view';
import type { PartnersPageViewModel } from '../../pages/partners-page/partners-page-view-model';
import { BASE_PATH } from '../../store';

export function partnersPageView(hrefPrefix: string, viewModel: AbstractPageView, state: State): PartnersPageViewModel {
  const o = state.organization;

  if (o === undefined) {
    throw new Error('Illegal state (E151), organization not found');
  }

  return {
    ...viewModel,
    type: 'partners-page',
    icon: 'partners',
    href: hrefPrefix,
    writeAccess: writeAccess(state),
    currentEmployeeUuid: currentEmployeeUuid(state),
    organizationId: getOrganizationId(state),
    availableActivityCodes: activityCodesAvailableHealth(),
    pdfHref: BASE_PATH + '/organizations/' + o.organizationId + '/overview.pdf?key=' + key(state),
    partnersAndContacts: getPartnersAndContacts(state),
  };
}
